import React, { useState } from "react";
import { roomsData } from "./Components/rooms";
import "bootstrap/dist/css/bootstrap.min.css";

const statusClasses = {
  available: "bg-success text-white",
  occupied: "bg-danger text-white",
  reserved: "bg-warning text-dark"
};

const HouseStatusView = () => {
  const [filter, setFilter] = useState("all");

  // Group rooms by type
  const groupedRooms = roomsData?.reduce((acc, room) => {
    acc[room.room_type] = acc[room.room_type] || [];
    acc[room.room_type].push(room);
    return acc;
  }, {});

  // Apply filter (All / Available / Occupied / Reserved)
  const filteredRooms =
    filter === "all"
      ? groupedRooms
      : Object.fromEntries(
          Object.entries(groupedRooms).map(([type, rooms]) => [
            type,
            rooms.filter((r) => r.status === filter)
          ])
        );

  // Count summary for footer
  const countByStatus = (status) =>
    roomsData.filter((r) => r.status === status).length;

  return (
    <div className="container-fluid py-3">
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">🏨 House Status View</h5>
          <div className="d-flex gap-2">
            <select
              className="form-select form-select-sm"
              style={{ width: "160px" }}
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="all">All</option>
              <option value="available">Available</option>
              <option value="occupied">Occupied</option>
              <option value="reserved">Reserved</option>
            </select>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search by Room..."
              style={{ width: "220px" }}
            />
          </div>
        </div>

        <div className="card-body table-responsive">
          <table className="table table-bordered align-middle text-center">
            <thead className="table-light">
              <tr>
                <th>Room Type / Units</th>
                <th>Available</th>
                <th>Occupied</th>
                <th>Reserved</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(filteredRooms).map(([type, rooms]) => (
                <React.Fragment key={type}>
                  <tr className="table-secondary fw-bold">
                    <td colSpan={4}>{type}</td>
                  </tr>
                  {rooms.map((room) => (
                    <tr key={room.id}>
                      <td>{room.room_number}</td>
                      <td
                        className={
                          room.status === "available"
                            ? statusClasses.available
                            : ""
                        }
                      >
                        {room.status === "available" && "🧹 Clean & Ready"}
                      </td>
                      <td
                        className={
                          room.status === "occupied"
                            ? statusClasses.occupied
                            : ""
                        }
                      >
                        {room.status === "occupied" && "👤 Stayover"}
                      </td>
                      <td
                        className={
                          room.status === "reserved"
                            ? statusClasses.reserved
                            : ""
                        }
                      >
                        {room.status === "reserved" && "📅 Reserved"}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
              <tr className="table-warning fw-bold">
                <td>Total</td>
                <td>{countByStatus("available")}</td>
                <td>{countByStatus("occupied")}</td>
                <td>{countByStatus("reserved")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default HouseStatusView;
